<template>
  <div>
    <div
      class="
        is-flex is-justify-content-center is-align-items-center
        has-text-centered
      "
      v-if="dataSource && dataSource.length == 0"
      style="height: 500px"
    >
      <div class="has-text-centered">
        <div
          style="
            width: 60px;
            height: 60px;
            position: relative;
            margin: 20px auto;
          "
        >
          <div
            class="
              is-flex is-justify-content-space-between is-align-items-center
            "
          >
            <div
              class="my-1 mr-2"
              style="width: 20%; height: 10px; background-color: #f2f2f2"
            ></div>
            <div
              class="my-1"
              style="width: 80%; height: 10px; background-color: #f2f2f2"
            ></div>
          </div>
          <div
            class="
              is-flex is-justify-content-space-between is-align-items-center
            "
          >
            <div
              class="my-1 mr-2"
              style="width: 20%; height: 10px; background-color: #f2f2f2"
            ></div>
            <div
              class="my-1"
              style="width: 80%; height: 10px; background-color: #f2f2f2"
            ></div>
          </div>
          <div
            class="
              is-flex is-justify-content-space-between is-align-items-center
            "
          >
            <div
              class="my-1 mr-2"
              style="width: 20%; height: 10px; background-color: #f2f2f2"
            ></div>
            <div
              class="my-1"
              style="width: 80%; height: 10px; background-color: #f2f2f2"
            ></div>
          </div>
        </div>
        <p class="has-text-grey">
          Select your preference filter and click generate
        </p>
      </div>
    </div>
    <div v-else>
      <div class="is-flex">
        <div class="mb-5" style="width: 250px">
          <div class="is-flex mb-0">
            <button
              class="button is-small btn-light mb-0"
              :disabled="dataTable.length == 0"
              @click="handleSelectAllTable"
            >
              <input
                class="mr-2"
                type="checkbox"
                :disabled="dataTable.length == 0"
                :checked="isCheckedAll"
              />
              <span> Select All</span>
            </button>
            <div
              class="dropdown mr-1"
              :class="activeDropdown && 'is-active'"
              @mouseleave="handleDropwdownActions(false)"
            >
              <div class="dropdown-trigger">
                <button
                  :disabled="!isAction"
                  class="button is-small btn-light mb-0"
                  aria-haspopup="true"
                  aria-controls="dropdown-menu"
                  @click="handleDropwdownActions(!activeDropdown)"
                >
                  <span>Actions</span>
                  <span class="icon is-small">
                    <i class="fa fa-angle-down" aria-hidden="true"></i>
                  </span>
                </button>
              </div>
              <div class="dropdown-menu" id="dropdown-menu" role="menu">
                <div class="dropdown-content">
                  <a class="dropdown-item" @click="generateExcelSummary">
                    <i class="fa fa-file mr-2"></i> Downloaded As Excel
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="width: 100%">
          <div class="field">
            <p class="control has-icons-left has-icons-right">
              <input
                class="input is-small custom-input"
                placeholder="Searching"
                v-model="searchQuery"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-search"></i>
              </span>
            </p>
          </div>
        </div>
      </div>

      <div
        class="is-flex is-justify-content-space-between"
        style="overflow: hidden"
      >
        <div
          class="table-fixed-left"
          :class="showShadowLeft && ' is-shadow-left'"
        >
          <table class="custom-table">
            <tr>
              <th
                class="standard-col is-border-y is-border-x has-text-centered"
                rowspan="2"
              >
                #
              </th>
              <th
                class="standard-col is-border-y is-border-x has-text-centered"
                rowspan="2"
              >
                Select
                <!-- <div
                class="
                  is-flex is-justify-content-center is-align-items-center
                  mt-2
                "
              >
                <input type="checkbox" />
              </div> -->
              </th>
              <th
                colspan="4"
                class="standard-col is-border-bottom is-border-y is-border-x"
              >
                Submission summary
                {{ !title ? "" : `for ${title.label} (Average 100 points)` }}
              </th>
            </tr>
            <tr>
              <th class="standard-col is-border-y is-border-x">Name</th>
              <th class="standard-col is-border-y is-border-x">Total Points</th>
              <th class="standard-col is-border-y is-border-x">
                Average Points
              </th>
            </tr>
            <tr
              v-for="(data, index) in dataTable"
              :key="index"
              style="height: 60px"
            >
              <td
                class="standard-col is-border-y is-border-x has-text-centered"
              >
                {{ index + 1 }}
              </td>
              <td class="standard-col is-border-y is-border-x">
                <div
                  class="
                    is-flex is-justify-content-center is-align-items-center
                  "
                >
                  <input
                    type="checkbox"
                    :checked="!data.checked ? false : true"
                  />
                </div>
              </td>
              <td class="standard-col is-border-y is-border-x">
                <p v-if="selectedIndex.row === index && loadingRow">
                  Loading...
                </p>
                <div v-else>
                  <h6 class="mb-1">
                    {{ !data.studentName ? "-" : data.studentName }}
                  </h6>
                  <p>{{ !data.className ? "-" : data.className }}</p>
                </div>
              </td>
              <td class="standard-col is-border-y is-border-x">
                <p v-if="selectedIndex.row === index && loadingRow">
                  Loading...
                </p>
                <p v-else>{{ !data.totalPoints ? "0" : data.totalPoints }}</p>
              </td>
              <td class="standard-col is-border-y is-border-x">
                <p v-if="selectedIndex.row === index && loadingRow">
                  Loading...
                </p>
                <p v-else>
                  {{
                    !data.category.studentAverage
                      ? "0"
                      : data.category.studentAverage
                  }}
                </p>
              </td>
            </tr>
          </table>
        </div>
        <div
          class="table-fixed-right"
          @scroll="onScroll"
          style="border-right: 1px solid #eaecf1"
        >
          <table class="custom-table">
            <tr>
              <th
                class="standard-col is-border-y is-border-x headerDarker"
                v-for="(item, index) in generateHeader"
                :key="index"
                colspan="2"
              >
                <div
                  style="
                    width: 300px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  "
                >
                  {{ item }}
                </div>
              </th>
            </tr>
            <tr>
              <th
                class="standard-col is-border-y is-border-x headerDarker"
                v-for="(item, index) in generateHeader.length * 2"
                :key="index"
              >
                {{ index % 2 == 0 ? "Total points" : "Total scale" }}
              </th>
            </tr>
            <tr
              v-for="(data, index) in dataTable"
              :key="index"
              style="height: 60px"
            >
              <td
                class="standard-col is-border-y is-border-x"
                v-for="(dataItem, i) in dataItemsTable[index]"
                :key="i"
              >
                <div
                  class="
                    is-flex
                    is-justify-content-space-between
                    is-align-items-center
                  "
                  style="width: 150px"
                  v-if="selectedIndex.row != index"
                >
                  <p v-if="selectedIndex.row === index && loadingRow">
                    Loading ...
                  </p>
                  <p class="mb-0" v-else>{{ dataItem }}</p>
                  <button
                    v-if="i % 2 != 0"
                    class="button is-small is-white is-light"
                    @click="handleEdit(index, parseInt(i / 2))"
                  >
                    <i class="fa fa-pencil"></i>
                  </button>
                </div>
                <div v-else style="width: 150px">
                  <p v-if="selectedIndex.row === index && loadingRow">
                    Loading ...
                  </p>
                  <div v-else>{{ dataItem }}</div>
                </div>
              </td>
            </tr>
          </table>
        </div>
        <!-- <div
        class="table-fixed-last"
        :class="showShadowRight && 'is-shadow-right'"
      >
        <table class="custom-table">
          <tr>
            <th
              class="standard-col is-border-y is-border-x"
              rowspan="2"
              style="text-align: center"
            >
              Actions
            </th>
            <th
              class="standard-col is-borderless"
              style="background: none"
            ></th>
          </tr>
          <tr>
            <th
              class="standard-col is-borderless"
              style="background: none"
            ></th>
          </tr>

          <tr v-for="(data, index) in dataTable" :key="index">
            <td class="standard-col bordered is-border-y">
              <button
                v-if="selectedIndex != index"
                class="button is-small is-white is-light"
                @click="handleEdit(index)"
              >
                <i class="fa fa-pencil"></i>
              </button>
              <div v-else>
                <button
                  class="button is-small is-white is-success"
                  @click="handleSave(data, index)"
                >
                  <i class="fa fa-check"></i>
                </button>
                <button
                  class="button is-small is-white is-danger"
                  @click="handleCancel"
                >
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </td>
          </tr>
        </table>
      </div> -->
      </div>

      <div class="modal" :class="visibleEditMode && 'is-active'">
        <div class="modal-background"></div>
        <div class="modal-card w-body">
          <header class="modal-card-head is-flex is-align-items-center">
            <h6 class="modal-card-title mb-0">
              {{
                selectedIndex.row != null &&
                dataTable[selectedIndex.row].category.items[selectedIndex.col]
                  .name
              }}
              ( Points: {{ points }} )
            </h6>
            <button
              class="delete"
              aria-label="close"
              @click="handleCancel"
            ></button>
          </header>
          <section class="modal-card-body">
            <!-- Content ... -->
            <div v-if="studentArraySubmission.loading" class="p-3 text-center">
              Loading...
            </div>
            <div v-else>
              <div
                class="
                  is-flex is-justify-content-space-between is-align-items-center
                "
              >
                <div>
                  <h6 class="mb-0">
                    {{
                      selectedIndex.row != null &&
                      dataTable[selectedIndex.row].studentName
                    }}
                  </h6>
                </div>
                <div>
                  <button
                    v-if="!studentArraySubmission.loading"
                    class="button mr-2 is-light is-small"
                    @click="handleAddNewSubmission"
                  >
                    New Submission
                    <!-- <b
                     :disabled="
                      currentTotalSubmission == submissionLimit ? true : false
                    "
                      class="ml-2"
                      v-if="
                        currentTotalSubmission != null &&
                        currentTotalSubmission != submissionLimit
                      "
                      >( {{ submissionLimit - currentTotalSubmission }} )</b 
                    >-->
                  </button>
                </div>
              </div>
              <div class="tableFixHead mt-4" id="scrollBottom">
                <table style="position: relative; display: table; width: 100%">
                  <thead class="header-table">
                    <tr>
                      <th class="has-text-centered is-size-7">Date</th>
                      <th class="has-text-centered is-size-7">
                        Scale
                        <p
                          class="
                            has-text-weight-light has-text-danger
                            is-size-6
                          "
                        >
                          Scale ( 1 to {{ scaleLimit }} )
                        </p>
                      </th>
                      <th class="has-text-centered is-size-7">Total Points</th>
                      <th class="has-text-centered is-size-7">Actions</th>
                    </tr>
                  </thead>
                  <tbody v-if="studentArraySubmission.data.length > 0">
                    <tr
                      v-for="(student, index) in studentArraySubmission.data"
                      :key="index"
                    >
                      <td
                        class="
                          standard-col
                          is-border-y is-border-x
                          has-text-centered
                          is-size-7
                        "
                      >
                        <div
                          class="
                            is-flex
                            is-justify-content-center
                            is-align-items-center
                            is-size-7
                          "
                          style="height: 35px"
                        >
                          <p class="mb-0" v-if="!student.enableToEditDate">
                            {{
                              selectedIndex.row != null &&
                              parseInt(student.date.substring(6, 8))
                            }}
                            {{
                              selectedIndex.row != null &&
                              monthArr.find(
                                (x, i) =>
                                  i + 1 ==
                                  parseInt(student.date.substring(5, 6))
                              )
                            }}
                            {{
                              selectedIndex.row != null &&
                              student.date.substring(0, 4)
                            }}
                          </p>
                          <InputCalender
                            v-else
                            :change="
                              (type, value) => {
                                handleDropdownChange(type, value, index);
                              }
                            "
                            :type="'day'"
                            :value="student.date"
                            :disableDate="disableDate"
                          />
                        </div>
                      </td>
                      <td
                        class="
                          standard-col
                          is-border-y is-border-x
                          has-text-centered
                          is-size-7
                        "
                      >
                        <div
                          class="
                            is-flex
                            is-justify-content-center
                            is-align-items-center
                          "
                          style="height: 35px"
                        >
                          <div
                            class="
                              input-group-btn
                              is-justify-content-space-between
                              is-align-items-center
                            "
                          >
                            <div>{{ student.totalScale }}</div>
                            <div class="groupBtn">
                              <button
                                class="btn-arrow btn-up"
                                @click="
                                  (e) =>
                                    handleSingleChangeSubmission(
                                      student.totalScale + 1,
                                      'totalScale',
                                      index
                                    )
                                "
                              >
                                <i class="fa fa-chevron-up"></i>
                              </button>
                              <button
                                class="btn-arrow btn-down"
                                @click="
                                  (e) =>
                                    handleSingleChangeSubmission(
                                      student.totalScale - 1,
                                      'totalScale',
                                      index
                                    )
                                "
                              >
                                <i class="fa fa-chevron-down"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td
                        class="
                          standard-col
                          is-border-y is-border-x
                          has-text-centered
                          is-size-7
                        "
                      >
                        <div
                          class="
                            is-flex
                            is-justify-content-center
                            is-align-items-center
                          "
                          style="height: 35px"
                        >
                          <p class="mb-0">
                            {{ student.totalScale * student.points }}
                          </p>
                        </div>
                      </td>
                      <td
                        class="
                          standard-col
                          is-border-y is-border-x
                          has-text-centered
                          is-size-7
                        "
                      >
                        <button
                          class="button is-small is-danger"
                          @click="(e) => handleRemoveItem(student.key)"
                        >
                          <i class="fa fa-times" />
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mt-3">
                <p class="mb-0 has-text-right is-size-6">
                  Total Points:
                  <b class="ml-2 mr-3">{{ sumtotalPoints }}</b>
                  Total Scale:
                  <b class="ml-2">{{ sumtotalScale }}</b>
                </p>
              </div>
            </div>
          </section>
          <footer class="modal-card-foot">
            <button class="button is-success is-small" @click="handleSave()">
              Save changes
            </button>
            <button class="button is-small" @click="handleCancel">
              Cancel
            </button>
          </footer>
        </div>
      </div>
    </div>
    <!-- pagination -->
    <!-- <div class="columns is-desktop mt-3" v-if="dataTable.length > 0">
      <div class="column">
        <div>
          <p
            class="
              is-flex is-justify-content-flex-start is-align-items-center
              m-0
              mr-3
              ml-3
              is-size-7
            "
          >
            {{ pagination.totalLimit }}
          </p>
        </div>
      </div>
      <div class="column">
        <div class="is-flex custom-justify-center is-align-items-center">
          <button style="border: 0px" class="button is-small mr-1 ml-1">
            Previous
          </button>
          <span v-for="pg in getTotalPage(pagination.currentPage)" :key="pg">
            <button
              style="border: 0px"
              class="button is-small mr-1 ml-1"
              :class="pg == pagination.currentPage && 'is-primary'"
              @click="handleChandePaginationSize('currentPage', pg)"
              :disabled="pg == pagination.currentPage"
            >
              {{ pg }}
            </button>
          </span>
          <button class="button is-small mr-1 ml-1" style="border: 0px">
            Next
          </button>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import axios from "axios";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { ToastProgrammatic as Toast } from "buefy";
import { putZeroInFront } from "./CustomFunction";
import InputCalender from "./InputCalender";

let monthArr = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export default {
  name: "table",
  components: {
    Loading,
    InputCalender,
  },
  props: [
    "dataSource",
    "loading",
    "title",
    "handleSelectAllTable",
    "generateExcelSummary",
    "filterItems",
    "fetchingStudentReportV2",
    "tagDataSource",
  ],
  data() {
    let date = new Date();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let day = date.getDate();
    let result =
      day + " " + monthArr.find((x, i) => i + 1 == month) + " " + year;
    return {
      loadingRow: false,
      searchQuery: "",
      studentArraySubmission: {
        loading: false,
        data: [],
      },
      daily: `${year}-${putZeroInFront(month)}-${putZeroInFront(day)}`,
      currentDate: result,
      monthArr,
      arrayTH: [],
      showShadowLeft: false,
      showShadowRight: true,
      visibleEditMode: false,
      selectedIndex: {
        row: null,
        col: null,
      },
      isCheckedAll: false,
      activeDropdown: false,
      isAction: false,
      dataTable: [],
      fakeData: [],
      dataItemsTable: [],
      editObj: {},
      pagination: {
        currentPage: 1,
        currentLimit: 20,
        totalPage: 0,
        totalLimit: 0,
      },
      scaleLimit: 0,
      points: 0,
      submissionLimitType: 0,
      submissionLimit: 0,
      sumtotalPoints: 0,
      sumtotalScale: 0,
      currentTotalSubmission: null,
      listOfRemoveData: [],
      disableDate: [],
    };
  },
  watch: {
    dataSource() {
      this.selectedIndex = {
        row: null,
        col: null,
      };

      // let newArrayData = this.dataSource.filter((x, i) => {
      //   return i < this.pagination.currentLimit && x;
      // });
      // this.dataTable = newArrayData;
      this.dataTable = this.dataSource;

      // this.pagination = {
      //   ...this.pagination,
      //   totalPage: Math.ceil(
      //     this.dataSource.length / this.pagination.currentLimit
      //   ),
      //   totalLimit: this.dataSource.length,
      // };

      let allArray = [];
      for (let idx = 0; idx < this.dataSource.length; idx++) {
        let newArr = [];
        if (this.dataSource && this.dataSource.length > 0) {
          let data =
            this.dataSource[idx].category &&
            this.dataSource[idx].category.items.map((x) => {
              return {
                points: x.totalPoints,
                scale: x.totalScale,
              };
            });
          for (
            let i = 0;
            i < this.dataSource[idx].category.items.length * 2;
            i++
          ) {
            let oddNum = Math.floor(i / 2);
            if (i % 2 == 0) {
              newArr.push(data[i / 2].points);
            } else {
              newArr.push(data[oddNum].scale);
            }
          }
        }
        allArray.push(newArr);
        this.dataItemsTable = allArray;
      }

      const checking = this.dataSource.filter((x) => x.checked);
      if (checking.length == this.dataSource.length) {
        this.isCheckedAll = true;
      } else {
        this.isCheckedAll = false;
      }

      if (checking.length > 0) {
        this.isAction = true;
      } else {
        this.isAction = false;
      }
    },
    fakeData() {
      this.dataTable = this.fakeData;
    },
    searchQuery() {
      const filterData = this.dataSource.filter((x) =>
        x.studentName.toLowerCase().includes(this.searchQuery)
      );
      if (this.searchQuery.length > 0) {
        this.dataTable = filterData;
        let allArray = [];
        for (let idx = 0; idx < filterData.length; idx++) {
          let newArr = [];
          if (filterData && filterData.length > 0) {
            let data =
              filterData[idx].category &&
              filterData[idx].category.items.map((x) => {
                return {
                  points: x.totalPoints,
                  scale: x.totalScale,
                };
              });
            for (
              let i = 0;
              i < filterData[idx].category.items.length * 2;
              i++
            ) {
              let oddNum = Math.floor(i / 2);
              if (i % 2 == 0) {
                newArr.push(data[i / 2].points);
              } else {
                newArr.push(data[oddNum].scale);
              }
            }
          }
          allArray.push(newArr);
          this.dataItemsTable = allArray;
        }
      } else {
        this.dataTable = this.dataSource;
        let allArray = [];
        for (let idx = 0; idx < this.dataSource.length; idx++) {
          let newArr = [];
          if (this.dataSource && this.dataSource.length > 0) {
            let data =
              this.dataSource[idx].category &&
              this.dataSource[idx].category.items.map((x) => {
                return {
                  points: x.totalPoints,
                  scale: x.totalScale,
                };
              });
            for (
              let i = 0;
              i < this.dataSource[idx].category.items.length * 2;
              i++
            ) {
              let oddNum = Math.floor(i / 2);
              if (i % 2 == 0) {
                newArr.push(data[i / 2].points);
              } else {
                newArr.push(data[oddNum].scale);
              }
            }
          }
          allArray.push(newArr);
          this.dataItemsTable = allArray;
        }
      }
    },
  },
  computed: {
    generateHeader() {
      let newArr = [];
      if (this.dataTable && this.dataTable.length > 0) {
        for (let i = 0; i < this.dataTable[0].category.items.length; i++) {
          newArr.push(this.dataTable[0].category.items[i].name);
        }
      }
      return newArr;
    },
  },
  methods: {
    handleDropdownChange(property, value, index) {
      this.handleSingleChangeSubmission(value, "date", index);
    },
    handleAddNewSubmission() {
      this.disableDate = [];
      let obj = {
        key: this.studentArraySubmission.data.length + 1,
        date: "",
        totalPoints: 0,
        totalScale: 0,
        submissionsCount: 0,
        enableToEditDate: true,
        submissionID: null,
        points: this.points,
        studentID: null,
        dataType: null,
      };

      let newData = [...this.studentArraySubmission.data, obj];
      this.studentArraySubmission = {
        ...this.studentArraySubmission,
        data: newData,
      };

      if (this.submissionLimitType == 1) {
        const data = newData;
        let array = data.map((x, i) => {
          return i == data.length - 1
            ? x.date
            : x.studentID == null
            ? x.date
            : this.convertDate(x.date);
        });
        for (let i = 0; i < array.length; i++) {
          this.getOccurrence(array, array[i]);
        }
      }

      setTimeout(() => {
        this.handleAutoScroll();
      }, 100);
    },
    getOccurrence(array, value) {
      var count = array.filter((v) => v === value).length;
      if (count >= 5) {
        const filters = this.disableDate.find((x) => x == value);
        if (filters == undefined) {
          this.disableDate = [...this.disableDate, value];
        }
      }
    },
    convertDate(date) {
      return `${date.substring(0, 4)}-${date.substring(4, 6)}-${date.substring(
        6,
        8
      )}`;
    },
    handleChandePaginationSize(property, value) {
      // let self = this;
      // let newArrayData = self.dataSource.filter((x, i) => {
      //   return (
      //     i > self.pagination.currentPage * 2 &&
      //     i < self.pagination.currentLimit * self.pagination.currentPage &&
      //     x
      //   );
      // });
      // self.dataTable = newArrayData;
      // self.pagination = {
      //   ...self.pagination,
      //   currentPage:
      //     property == "currentLimit" ? 1 : self.pagination.currentPage,
      //   [property]: value,
      // };
    },
    range(from, to, step = 1) {
      let i = from;
      const range = [];

      while (i <= to) {
        range.push(i);
        i += step;
      }
      return range;
    },
    getTotalPage(current) {
      let pages = Math.ceil(
        this.pagination.totalLimit / this.pagination.currentLimit
      );
      const start = current > 3 ? Math.max(2, current - 2) : 1;
      const end = Math.min(pages, current + 2);

      return this.range(start, end);
    },
    handleDropwdownActions(value) {
      this.activeDropdown = value;
    },
    handleSelectAll() {
      const self = this;
      if (!self.selectAll) {
        let newData = self.dataTable.map((x) => {
          return {
            ...x,
            checked: true,
          };
        });
        self.dataTable = newData;
      } else {
        let newData = self.dataTable.map((x) => {
          return {
            ...x,
            checked: false,
          };
        });
        self.dataTable = newData;
      }
      self.selectAll = !self.selectAll;
    },
    handleOnChange(e, index, data) {
      // let self = this;
      // let { target } = e;
      // let value = target.value;
      // self.fakeData = [];
      // const indexItems = index;
      // const indexReport = self.selectedIndex.row;
      // const newData = [...self.dataSource];
      // // let newDataFake = [...this.fakeData];
      // let newItemsArray = newData[indexReport].category.items;
      // // let newItemsFake = newDataFake[indexReport].category.items;
      // let selectedItem = newItemsArray[indexItems];
      // // let selectedItemFake = newItemsFake[indexItems];
      // let obj = {
      //   ...selectedItem,
      //   totalScale: parseInt(value),
      // };
      // let newObj = {
      //   studentID: newData[indexReport].studentID,
      //   startDate: newData[indexReport].startDate,
      //   endDate: newData[indexReport].endDate,
      // };
      // self.editObj = { ...newObj, ...obj };
      // newItemsArray.splice(indexItems, 1, {
      //   ...selectedItem,
      //   ...obj,
      // });
      // // console.log("selectedItem", selectedItem);
      // // console.log(("selectedItemFake", selectedItemFake));
      // // console.log(newItemsArray);
      // // Start Count average
      // // if maxDailyScale equal to -1 than value == categoryAverage.
      // // if maxDailyScale > 0 than value (maxPossiblePointsPerBehavior / maxPossiblePointsPerBehavior) X categoryAverage)
      // // to get totalPoint is points * totalScale
      // // to get maxPossiblePointsPerBehavior is points * maxDailyScale
      // // to get totalAveragePoint is additional averagePoint from the list of items
      // // to get studentAverage totalAveragePoint/total items
      // // if totalScale and totalPoints == 0 ? has no submission and totalAverage == 0
      // let totalAverageAllItem = [];
      // for (let i = 0; i < newItemsArray.length; i++) {
      //   let totalAverage = self.count(newItemsArray[i]);
      //   totalAverageAllItem.push(totalAverage);
      // }
      // let countStudentAverage = totalAverageAllItem.reduce((a, b) => a + b, 0);
      // let totalAverageStudentPoint = countStudentAverage / newItemsArray.length;
      // let itemObj = {
      //   ...newData[indexReport],
      //   category: {
      //     ...newData[indexReport].category,
      //     items: newItemsArray,
      //     studentAverage:
      //       Math.round(totalAverageStudentPoint) != 100
      //         ? totalAverageStudentPoint.toFixed(2)
      //         : Math.round(totalAverageStudentPoint),
      //   },
      // };
      // newData.splice(indexReport, 1, { ...newData[indexReport], ...itemObj });
      // self.fakeData = newData;
    },
    handleRemoveItem(key) {
      const copyData = [...this.studentArraySubmission.data];
      const filterData = copyData.filter((x) => x.key != key);
      this.studentArraySubmission = {
        ...this.studentArraySubmission,
        data: filterData,
      };

      let checking = copyData.find((x) => x.key == key);
      if (checking.submissionID != null) {
        this.listOfRemoveData = [...this.listOfRemoveData, checking];
      }

      if (this.submissionLimitType == 1) {
        if (checking.submissionID == null) {
          const sumLimit =
            copyData.filter((x) => x.submissionID == null).length - 1;
          this.currentTotalSubmission = sumLimit;
        }
      } else if (this.submissionLimitType == 2) {
        const sumLimit = copyData.length - 1;
        this.currentTotalSubmission = sumLimit;
      } else {
        this.currentTotalSubmission = null;
      }

      this.sumtotalPoints = filterData
        .map((x) => x.totalScale * x.points)
        .reduce((a, b) => a + b, 0);
      this.sumtotalScale = filterData
        .map((x) => x.totalScale)
        .reduce((a, b) => a + b, 0);
    },
    handleSingleChangeSubmission(value, property, index) {
      this.sumtotalPoints = 0;
      this.sumtotalScale = 0;
      let newData = [...this.studentArraySubmission.data];
      let item = newData[index];

      let obj = {};
      if (property != "date") {
        obj = {
          ...item,
          [property]:
            this.scaleLimit != -1 && value > this.scaleLimit
              ? this.scaleLimit
              : value < 0
              ? 0
              : value,
        };
      } else {
        obj = {
          ...item,
          [property]: value,
        };
      }
      newData.splice(index, 1, { ...item, ...obj });

      this.sumtotalPoints = newData
        .map((x) => x.totalScale * x.points)
        .reduce((a, b) => a + b, 0);
      this.sumtotalScale = newData
        .map((x) => x.totalScale)
        .reduce((a, b) => a + b, 0);

      this.studentArraySubmission = {
        ...this.studentArraySubmission,
        data: newData,
      };
    },
    count(value) {
      let totalStudentPoints = value.points * value.totalScale;
      let maxPossiblePointsPerBehavior = value.points * value.maxDailyScale;
      let categoryAverage =
        this.dataTable[this.selectedIndex.row].category.categoryAverage;

      if (value.maxDailyScale === -1) {
        return categoryAverage;
      } else if (value.maxDailyScale > 0) {
        if (value.totalScale === 0 && value.totalPoints === 0) {
          return 0;
        } else {
          if (totalStudentPoints >= value.points) {
            return (
              (maxPossiblePointsPerBehavior / maxPossiblePointsPerBehavior) *
              categoryAverage
            );
          } else {
            return (
              (totalStudentPoints / maxPossiblePointsPerBehavior) *
              categoryAverage
            );
          }
        }
      } else {
        return 0;
      }
    },
    covertToFormatTable(data) {
      return data.map((x, i) => {
        return {
          key: i,
          date: x.actionDate,
          totalPoints: x.totalPoints,
          totalScale: x.multiply,
          enableToEditDate: false,
          submissionID: x._id,
          points: this.points,
          studentID: x.studentID,
          dataType: x.dataType,
        };
      });
    },
    async handleSave() {
      this.visibleEditMode = !this.visibleEditMode;
      this.$swal({
        title: "",
        text: "Loading...",
        timer: 3000,
        closeOnClickOutside: false,
        showConfirmButton: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      let currentData = this.studentArraySubmission.data;
      let copydata = [...this.studentArraySubmission.data];

      const checkingNewData = currentData.filter((x) => x.submissionID == null);

      if (checkingNewData.length > 0) {
        console.log("save new data first");
        const add = await this.handleAddSubmission(checkingNewData);
        currentData = add;
      }
      const checkingExisting = copydata.filter((x) => x.submissionID != null);

      if (checkingExisting.length > 0) {
        console.log("update first");
        const update = await this.handleUpdate(checkingExisting);
        currentData = update;
      }

      const checkingRemoveData = this.listOfRemoveData;
      if (checkingRemoveData.length > 0) {
        console.log("remove existing data first");
        const revoke = await this.handleRevoke(checkingRemoveData);
        currentData = revoke;
      }
      this.getLatestUpdatedData(true);
    },
    async handleUpdate(data) {
      let payload = {
        token: localStorage.getItem("jwtTokenV2"),
        email: localStorage.getItem("email"),
        studentID: this.dataTable[this.selectedIndex.row].studentID,
        itemID:
          this.dataTable[this.selectedIndex.row].category.items[
            this.selectedIndex.col
          ]._id,
        action: "update",
        submissions: data
          .filter((x) => x.submissionID != null)
          .map((x) => {
            return {
              submissionID: x.submissionID,
              date: x.date,
              scale: x.totalScale,
            };
          })
          .filter((x) => x.submissionID != null),
      };
      await axios
        .post(process.env.NEW_ENDPOINT + "/submissions/submitSummary", payload)
        .then((res) => {})
        .catch(() => {});

      const latestUpdateData = this.getLatestUpdatedData(false);
      return latestUpdateData;
    },
    async handleRevoke(data) {
      let revokeData = data;
      let submissionsToRevoke = [];

      if (data && data.length > 0) {
        revokeData.forEach(function (element) {
          var elementID =
            "1:" +
            element.dataType +
            "|2:" +
            element.submissionID +
            "|3:" +
            element.studentID +
            "|4:" +
            element.date;
          submissionsToRevoke.push(elementID);
        });
      }

      if (submissionsToRevoke.length > 0) {
        await axios
          .post(process.env.NEW_ENDPOINT + "/submissions/revoke/", {
            token: localStorage.getItem("jwtTokenV2"),
            email: localStorage.getItem("email"),
            submissionsToRevoke: submissionsToRevoke,
          })
          .then((response) => {
            if (response.data.success == false) {
              // Toast.open({
              //   message: response.data.msg,
              //   type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
              //   duration: 5000,
              // });
            } else {
              Toast.open({
                color: "is-dark", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                message: response.data.msg,
                type: "is-success",
                duration: 3000,
              });
            }
          })
          .catch((e) => {
            // console.log(e);
            if (e.response.status === 401) {
              Toast.open({
                message: "Unauthorized access. Please re-login.",
                type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                duration: 5000,
              });
            } else {
              Toast.open({
                message: "Error: " + e.response.data.msg,
                type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                duration: 5000,
              });
            }
          });
      }
      const latestUpdateData = this.getLatestUpdatedData(false);
      return latestUpdateData;
    },
    async handleAddSubmission(data) {
      let payload = {
        token: localStorage.getItem("jwtTokenV2"),
        email: localStorage.getItem("email"),
        studentID: this.dataTable[this.selectedIndex.row].studentID,
        itemID:
          this.dataTable[this.selectedIndex.row].category.items[
            this.selectedIndex.col
          ]._id,
        action: "add",
        submissions: data.map((x) => {
          let date = x.date.split("-");
          return {
            date: date[0] + date[1] + date[2],
            scale: x.totalScale,
            count: x.submissionsCount,
          };
        }),
      };

      if (data && data.length > 0) {
        await axios
          .post(
            process.env.NEW_ENDPOINT + "/submissions/submitSummary",
            payload
          )
          .then((response) => {
            // ;
            // this.visibleEditMode = false;
          })
          .catch((err) => {
            // ;
            // this.visibleEditMode = false;
            this.selectedIndex = {
              row: null,
              col: null,
            };
            this.scaleLimit = 0;
            this.submissionLimitType = 0;
            this.submissionLimit = 0;
            Toast.open({
              message: err,
              type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
              duration: 5000,
            });
          });
      }

      const latestUpdateData = this.getLatestUpdatedData(false);
      return latestUpdateData;
    },
    async getLatestUpdatedData(update) {
      const findingRowData = this.dataTable[this.selectedIndex.row];
      const response = await axios.post(
        process.env.MY_URL + "/api/reportsV2/summaryWithDetails",
        {
          studentID: findingRowData.studentID,
          startDate: findingRowData.startDate,
          endDate: findingRowData.endDate,
          categoryID: this.filterItems.behaviorID[0],
        }
      );

      let newData = [];
      if (!update) {
        if (response.status == 200 && response.data.success) {
          if (
            response.data.category.items[this.selectedIndex.col].submissions &&
            response.data.category.items[this.selectedIndex.col].submissions
              .length > 0
          ) {
            newData =
              response.data.category.items[this.selectedIndex.col].submissions;
          }
          this.studentArraySubmission = {
            ...this.studentArraySubmission.data,
            data: this.covertToFormatTable(newData),
          };
        }
      } else {
        setTimeout(() => {
          this.handleCancel();
        }, 10);
        const arr = this.dataTable;
        let newObj = { ...response.data };
        arr.splice(this.selectedIndex.row, 1, {
          ...findingRowData,
          ...newObj,
        });
        let allArray = [];
        let newArr = [];
        let data =
          newObj.category &&
          newObj.category.items.map((x) => {
            return {
              points: x.totalPoints,
              scale: x.totalScale,
            };
          });
        for (let i = 0; i < newObj.category.items.length * 2; i++) {
          let oddNum = Math.floor(i / 2);
          if (i % 2 == 0) {
            newArr.push(data[i / 2].points);
          } else {
            newArr.push(data[oddNum].scale);
          }
        }
        allArray.push(newArr);
        this.dataItemsTable = allArray;
        this.$swal("Good job!", response.data.msg, "success");
      }

      return newData;
    },
    handleEdit(index, indexCol) {
      this.visibleEditMode = !this.visibleEditMode;
      this.loadingRow = true;
      this.selectedIndex = {
        row: index,
        col: indexCol,
      };
      this.studentArraySubmission = {
        ...this.studentArraySubmission,
        data: [],
      };
      this.scaleLimit = 0;
      this.submissionLimitType = 0;
      this.submissionLimit = 0;

      this.fetchingSummary();
    },
    handleCancel() {
      this.dataTable = this.dataSource;
      this.visibleEditMode = false;
      this.selectedIndex = {
        row: null,
        col: null,
      };
      this.scaleLimit = 0;
      this.submissionLimitType = 0;
      this.submissionLimit = 0;
      this.listOfRemoveData = [];
    },
    fetchingSummary() {
      const checkingData =
        this.dataTable[this.selectedIndex.row].category.items[
          this.selectedIndex.col
        ];

      this.scaleLimit = checkingData.scaleLimit;
      this.submissionLimitType = checkingData.submissionLimitType;
      this.submissionLimit = checkingData.submissionLimit;
      this.points = checkingData.points;
      this.currentTotalSubmission =
        this.submissionLimitType == 2
          ? checkingData.submissions.length
          : this.submissionLimitType == 1
          ? 0
          : null;

      if (checkingData.submissions && checkingData.submissions.length) {
        this.sumtotalPoints = checkingData.submissions
          .map((x) => x.totalPoints)
          .reduce((a, b) => a + b, 0);
        this.sumtotalScale = checkingData.submissions
          .map((x) => x.multiply)
          .reduce((a, b) => a + b, 0);

        let data = this.covertToFormatTable(checkingData.submissions);

        this.studentArraySubmission = {
          ...this.studentArraySubmission,
          data: data,
        };
      }
      // this.studentArraySubmission = {
      //   ...this.studentArraySubmission,
      //   loading: true,
      // };
      // const self = this;
      // let date = new Date();
      // let month = date.getMonth() + 1;
      // let day = this.filterItems.month == month ? date.getDate() : 31;
      // let promises = [];
      // let summaryData = [];
      // console.log(day, this.filterItems.month, date.getDate());
      // try {
      //   for (var i = 0; i < day; i++) {
      //     let payload = {
      //       studentID: self.dataTable[this.selectedIndex.row].studentID,
      //       startDate: `${this.filterItems.year}${putZeroInFront(
      //         this.filterItems.month
      //       )}${putZeroInFront(i + 1)}`,
      //       endDate: `${this.filterItems.year}${putZeroInFront(
      //         this.filterItems.month
      //       )}${putZeroInFront(i + 1)}`,
      //       categoryID: self.filterItems.behaviorID[0],
      //     };
      //     promises.push(
      //       await axios.post(
      //         process.env.MY_URL + "/api/reportsV2/summaryWithDetails",
      //         payload
      //       )
      //     );
      //     let response = await Promise.all(promises);

      //     if (response.length == day) {
      //       for (var i = 0; i < response.length; i++) {
      //         summaryData.push(response[i].data);
      //       }
      //     }

      //     let newArray = [];
      //     summaryData.map((element) => {
      //       let items = element.category.items
      //         .map((x) => {
      //           return {
      //             ...x,
      //             submissionsCount: element.category.submissionsCount,
      //           };
      //         })
      //         .filter((x, i) => i == this.selectedIndex.col)
      //         .filter((x) => x.submissions);
      //       newArray.push(items);
      //       return items;
      //     });
      //     let filterHasData = newArray
      //       .filter((x) => x.length > 0)
      //       .map((x, i) => {
      //         return {
      //           key: i,
      //           date: x[0].submissions[0].actionDate,
      //           totalPoints: x[0].totalPoints,

      //           totalScale: x[0].totalScale,
      //           submissionsCount: x[0].submissionsCount,
      //           enableToEditDate: false,
      //           submissionID: x[0].submissions[0]._id,
      //         };
      //       });

      //     this.studentArraySubmission = {
      //       ...this.studentArraySubmission,
      //       data: filterHasData,
      //     };
      //   }
      // } catch (err) {
      //   this.studentArraySubmission = {
      //     ...this.studentArraySubmission,
      //     loading: false,
      //   };
      // }
      // this.studentArraySubmission = {
      //   ...this.studentArraySubmission,
      //   loading: false,
      // };
    },
    handleAutoScroll(e) {
      var element = document.getElementById("scrollBottom");
      element.scrollTo({
        top: element.scrollHeight,
        left: 0,
        behavior: "smooth",
      });
    },
    onScroll(e) {
      const { target } = e;
      const self = this;
      let current = target.scrollLeft;
      if (current == 0) {
        self.showShadowLeft = false;
        self.showShadowRight = true;
      } else {
        self.showShadowLeft = true;
        self.showShadowRight = true;
      }
    },
  },
};
</script>
<style>
.is-borderless {
  border: none;
}

.custom-table th,
.custom-table td {
  border: none !important;
}

.custom-table th {
  background: #f7f7f7;
  vertical-align: middle !important;
}

.custom-table .is-border-top {
  border-top: 1px solid #eaecf1 !important;
}

.custom-table .is-border-left {
  border-left: 1px solid #eaecf1 !important;
}

.custom-table .is-border-right {
  border-right: 1px solid #eaecf1 !important;
}

.custom-table .is-border-bottom {
  border-bottom: 1px solid #eaecf1 !important;
}

.custom-table .is-border-y {
  border-right: 1px solid #eaecf1 !important;
  border-left: 1px solid #eaecf1 !important;
}

.custom-table .is-border-x {
  border-top: 1px solid #eaecf1 !important;
  border-bottom: 1px solid #eaecf1 !important;
}

.table-fixed-left td,
.table-fixed-last td,
.table-fixed-right td,
.table-fixed-left th,
.table-fixed-last th,
.table-fixed-right th {
  height: 43px;
}

.table-fixed-left table,
.table-fixed-right table {
  border-collapse: collapse;
}
.table-fixed-right td,
.table-fixed-right th,
.table-fixed-left td,
.table-fixed-left th {
  border: unset;
  padding: 5px 5px;
  vertical-align: middle !important;
}

.is-shadow-left {
  box-shadow: 2px 0px 30px rgb(10 10 10 / 10%) !important;
  transition: ease 500ms;
}

.is-shadow-right {
  box-shadow: -2px 0px 30px rgb(10 10 10 / 10%) !important;
  transition: ease 500ms;
}

.table-fixed-left {
  width: calc(50%);
  white-space: nowrap;
  overflow-x: scroll;
  font-size: 12px;
  text-align: left;
  border: unset;
  z-index: 0;
  /* box-shadow: 0px 0px 0px #a8a7b4; */
}
.table-fixed-right {
  width: calc(50%);
  white-space: nowrap;
  overflow-x: scroll;
  font-size: 12px;
  text-align: left;
  border: unset;
  z-index: 0;
}
.table-fixed-last {
  max-width: 100px;
  white-space: nowrap;
  font-size: 12px;
  /* text-align: center; */
  border: unset;
  z-index: 0;
  /* box-shadow: 0px 0px 0px #a8a7b4; */
}
.table-fixed-right td,
.table-fixed-right th {
  padding: 5px 10px;
}

.bordered-header {
  border-bottom: 2px solid #dde0ea !important;
}

.tableFixHead {
  overflow-y: auto;
  height: 250px;
  border: 1px solid #eaecf1 !important;
}
.tableFixHead thead th {
  position: sticky;
  top: -1px;
}
.tableFixHead table {
  border-collapse: collapse;
  width: 100%;
}
.tableFixHead th,
.tableFixHead td {
  padding: 8px 16px;
  border: 1px solid #eaecf1 !important;
}
.tableFixHead th {
  background: #f7f7f7;
  z-index: 2;
}
.groupBtn {
  position: relative;
  display: grid;
}
.btn-arrow {
  /* display: flex; */
  align-items: center;
  height: 14px;
  padding: 0px 8px;
  font-size: 8px;
  background: none;
  border: 1px solid;
  border-right: 0px;
  color: #b3b4b7;
  border-color: #dbdbdb;
}
.btn-arrow.btn-up {
  border-top: 0px;
}
.btn-arrow.btn-down {
  border-bottom: 0px;
}
.input-group-btn {
  overflow: hidden;
  padding-left: 12px;
  border: 1px solid;
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 150px;
  font-size: 14px;
  border-radius: 2px;
  border-color: #dbdbdb;
}

.headerDarker {
  background-color: #e9e9e9 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/OverallReporting/Table.vue